import _ from 'lodash'
import Mustache from 'mustache'
import { call, put, select, takeLatest } from 'redux-saga/effects'

import CONSTANTS from 'core/data-model/constants/messages'
import MESSAGES from 'core/data-model/constants/validation-messages'
import { renderUnit } from 'core/service/insured/age'
import { isValidAge } from 'core/service/insured/birthdate'
import {
  getAge,
  getAllNatureOfDutyCodes,
  getInsured,
  getPayerAge,
  getPayerGender,
  getPayerRelation,
} from 'quick-quote/insured-information/selectors'
import { updateBasicPlanErrorMessage } from 'quick-quote/product-common/coverage-plan/actions'
import { updateCoveragePlanState } from 'quick-quote/product-common/coverage-plan/sagas'
import { getAvailableRiders } from 'quick-quote/product-common/coverage-plan/selectors'
import {
  getDisplayProducts,
  getSelectedDisplayProduct,
  getSelectedDisplayProductQuery,
} from 'quick-quote/product-selection/selectors'

import { selectBasicPlan, UPDATE_SELECTED_BASIC_PLAN, VALIDATE_BASIC_PLAN, validateBasicPlan } from './actions'
import { getSelectedModelFactorID } from './selectors'

export function createProductHealthFunc() {
  const onUpdateSelectedBasicPlan = function*(action) {
    const basicPlanCode = action.payload
    const displayProducts = yield select(getDisplayProducts)
    const product = _.find(displayProducts, { code: basicPlanCode })
    !!product && (yield put(selectBasicPlan(product)))
  }

  const generateCoveragePlanFromBasicPlanChange = function*(calculateCoveragePlanFn) {
    const displayProductQuery = yield select(getSelectedDisplayProductQuery)
    const natureOfDutyCodes = yield select(getAllNatureOfDutyCodes)
    const insured = yield select(getInsured)
    const modelFactorID = yield select(getSelectedModelFactorID)
    const availableRiders = yield select(getAvailableRiders)
    const payerAge = yield select(getPayerAge)
    const payerGender = yield select(getPayerGender)
    const payerRelation = yield select(getPayerRelation)
    const newValue = yield call(calculateCoveragePlanFn, {
      displayProductQuery,
      insured,
      natureOfDutyCodes,
      modelFactorID,
      availableRiders,
      payerAge,
      payerGender,
      payerRelation,
    })
    yield call(updateCoveragePlanState, newValue)
    yield put(validateBasicPlan())
  }

  const getValidationMessage = (displayProduct, age) => {
    const { entryAge } = displayProduct
    if (!entryAge || isValidAge(age.value, age.unit, entryAge)) {
      return ''
    }
    return Mustache.render(MESSAGES.RULE_AGE, {
      owner: CONSTANTS.INSURED_PERSON,
      minimumAge: `${entryAge.minimum.value} ${renderUnit(entryAge.minimum.unit)}`,
      maximumAge: `${entryAge.maximum.value} ${renderUnit(entryAge.maximum.unit)}`,
    })
  }

  const onValidateBasicPlan = function*() {
    const selectedDisplayProduct = yield select(getSelectedDisplayProduct)
    const age = yield select(getAge)
    const message = yield call(getValidationMessage, selectedDisplayProduct, age)
    return yield put(updateBasicPlanErrorMessage(message))
  }

  return {
    onUpdateSelectedBasicPlan,
    generateCoveragePlanFromBasicPlanChange,
    onValidateBasicPlan,
  }
}

/**
 * @param serviceWrapper {Awaited<ReturnType<import('core/service-wrapper/wrapper').buildServiceWrapper>>}
 */
export function* sagas(serviceWrapper) {
  const { HEALTH } = serviceWrapper.products
  yield [
    takeLatest(UPDATE_SELECTED_BASIC_PLAN, HEALTH.onUpdateSelectedBasicPlan),
    // saga impact current product remove take latest for now becaseu product is off-shelf
    //takeLatest(SELECT_BASIC_PLAN, generateCoveragePlanFromBasicPlanChange, calculateCoveragePlanFromBasicPlanChange),
    takeLatest(VALIDATE_BASIC_PLAN, HEALTH.onValidateBasicPlan),
  ]
}
